import React from "react";
import { MessageCircle, Phone } from "lucide-react";
import { Button } from "./ui/button";
import { clinic } from "../data/mock";
import { getWhatsAppLink } from "../lib/whatsapp";

const AppointmentCTA = ({ title, subtitle }) => {
  return (
    <section className="py-16 sm:py-20">
      <div className="container-app">
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-sky-500 to-sky-700 px-6 py-14 sm:px-14 text-center">
          <div className="absolute -top-16 -right-16 w-64 h-64 rounded-full bg-white/10" />
          <div className="absolute -bottom-20 -left-16 w-72 h-72 rounded-full bg-white/10" />
          <div className="relative">
            <h2 className="font-heading text-3xl sm:text-4xl font-bold text-white max-w-2xl mx-auto">
              {title || "Ready to Take Charge of Your Liver Health?"}
            </h2>
            <p className="mt-4 text-sky-50 max-w-2xl mx-auto text-lg">
              {subtitle || `Book a consultation with ${clinic.doctorName} today. Early diagnosis and expert care make all the difference.`}
            </p>
            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
              <a href={getWhatsAppLink()} target="_blank" rel="noopener noreferrer">
                <Button size="lg" className="bg-white text-sky-600 hover:bg-sky-50 rounded-full px-8 h-12 text-base font-semibold shadow-xl">
                  <MessageCircle size={20} className="mr-2" /> Book on WhatsApp
                </Button>
              </a>
              <a href={`tel:${clinic.phone.replace(/\s/g, "")}`}>
                <Button size="lg" variant="outline" className="bg-transparent border-white text-white hover:bg-white/10 rounded-full px-8 h-12 text-base font-semibold">
                  <Phone size={20} className="mr-2" /> {clinic.phone}
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppointmentCTA;
